// Route Code Edited 05/15/2026
/**
 * Route Dialog Handler
 *
 * Patches HTMLDialogElement.prototype.showModal to open the cart drawer
 * via show() instead of showModal(), preventing it from entering the
 * top layer and blocking Route's modal from rendering above it.
 *
 * Injects a synthetic backdrop and positioning styles to replicate showModal() visuals.
 *
 */
(function () {
  const _showModal = HTMLDialogElement.prototype.showModal;

  HTMLDialogElement.prototype.showModal = function () {
    if (this.classList.contains('cart-drawer__dialog')) {
      if (!document.getElementById('non-modal-drawer-cart-styles')) {
        const style = document.createElement('style');
        style.id = 'non-modal-drawer-cart-styles';
        style.textContent = `
          dialog.cart-drawer__dialog[open] {
            top: 0 !important;
            z-index: 9;
          }
          .cart-backdrop {
            position: fixed;
            inset: 0;
            z-index: 8;
            pointer-events: none;
            background: rgba(0, 0, 0, 0.375);
            opacity: 0;
            transition: none !important;
          }
          .cart-drawer:has(.cart-drawer__dialog[open]) .cart-backdrop {
            opacity: 1;
            pointer-events: auto;
          }
          #header-component:has(.cart-drawer__dialog[open]) {
            contain: style;
          }`;
        document.head.appendChild(style);
      }

      // Ensure backdrop exists directly before the dialog in the DOM
      let backdrop = this.parentNode.querySelector(':scope > div.cart-backdrop');
      if (!backdrop) {
        backdrop = document.createElement('div');
        backdrop.classList.add('cart-backdrop');
      }
      if (this.previousElementSibling !== backdrop) {
        this.parentNode.insertBefore(backdrop, this);
      }

      this.show();
    } else {
      _showModal.call(this);
    }
  };
})();
// End Route Code